import React, { useEffect, useRef, useState } from "react";
import {
  GoogleMap,
  InfoWindow,
  Marker,
  Circle,
  Polygon,
} from "@react-google-maps/api";
import wellIcon from "../assets/images/rwell.png";
import ChangeMapType from "./Layers/ChangeMapType";
import "./Map.css";
import mapmarker from "../assets/images/mapmarker.png";
import Sidebar from "../Sidebar";
import Alert from "@mui/material/Alert";
import { useJsApiLoader } from "@react-google-maps/api";
import { mapOptions } from "./MapConfiguration";
import Navbar from "../navbar";
import Leftbar from "../leftbar";
import geoJson from "./bangladesh.json"; // adjust path as needed
import divisionJson from "./division_boundaries_v3.json";
import districtJson from "./district_boundaries_v3.json";
import divisionData from "./divisionData.json";
import districtData from "./districtData.json";
import mapmarkergreen from "../assets/images/mapmarkergreen.png";
import { OverlayView } from "@react-google-maps/api";

// Utility to get center of polygon
const getPolygonCenter = (coordinates) => {
  const latSum = coordinates.reduce((sum, coord) => sum + coord.lat, 0);
  const lngSum = coordinates.reduce((sum, coord) => sum + coord.lng, 0);
  return {
    lat: latSum / coordinates.length,
    lng: lngSum / coordinates.length,
  };
};

// Utility function to generate random colors
const generateRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

// Predefined color palette (optional)
const colorPalette = [
  "#FFDDC1",
  "#FFABAB",
  "#FFC3A0",
  "#FF677D",
  "#D4A5A5",
  "#392F5A",
  "#31A2AC",
  "#61C0BF",
  "#6B4226",
  "#D9BF77",
];

const getRandomColor = () => {
  return colorPalette[Math.floor(Math.random() * colorPalette.length)];
};

const Map = (props) => {
  const { isLoaded } = props;
  const [paths, setPaths] = useState([]);
  const [divisionPaths, setDivisionPaths] = useState([]);
  const [districtPaths, setDistrictPaths] = useState([]);
  const [mapCenter, setMapCenter] = useState({ lat: 24.3746, lng: 88.6004 });
  const [zoom, setZoom] = useState(props.zoom);
  const [datalogs, setDatalogs] = useState([]);
  const [imdatalogs, setimDatalogs] = useState([]);
  const [multiColImDatalogs, setMultiColImDatalogs] = useState([]);
  const [regionClicked, setRegionClicked] = useState(false);
  const [regions, setRegions] = useState([]);

  const [selectedMarker, setSelectedMarker] = useState(null);
  const [markers, setMarkers] = useState([]);
  const [radius, setRadius] = useState(0); // State to store radius value
  const [circleCenter, setCircleCenter] = useState(null); // State to store circle center
  const mapRef = useRef(null);
  const [showRegionInfo, setShowRegionInfo] = useState(false); // New state to control region info visibility
  const [latLng, setLatLng] = useState(null); // New state for storing lat/lng
  const [isPickingLocation, setIsPickingLocation] = useState(false); // New state for Pick a Location button
  const [isBuildingWell, setIsBuildingWell] = useState(false); // New state for Pick a Location button
  const [showCircle, setShowCircle] = useState(true); // Define showCircle and hideCircle
  const [showStat, setShowStat] = useState(false); // Define showStat and setShowStat
  const [locationMarkers, setLocationMarkers] = useState([]); // Define locationMarkers and setLocationMarkers
  const [userFriendlyLocation, setUserFriendlyLocation] = useState(null); // Define userFriendlyLocation and setUserFriendlyLocation
  const handleClearLeftbar = () => {
    setShowRegionInfo(false);
    setSelectedColor(null);
    setSelectedMarker(null);
    //Reload
    window.location.reload();
  };

  const [selectedColor, setSelectedColor] = useState(null);

  const [markerPosition, setMarkerPosition] = useState(null);
  const mapHasSidePanel = Boolean(selectedMarker);
  /* Map size/offset is driven by .map-layout__map-host in mapshow.css so it matches fixed sidebar width */
  const mapContainerStyle = {
    width: "100%",
    height: "100%",
    margin: 0,
    borderRadius: 0,
    zIndex: 1,
  };

  /* Custom PNG markers need scaledSize + anchor; build after google.maps is ready */
  const [wellMarkerIcon, setWellMarkerIcon] = useState(null);
  const [selectedWellMarkerIcon, setSelectedWellMarkerIcon] = useState(null);
  useEffect(() => {
    if (!isLoaded || typeof window === "undefined" || !window.google?.maps) {
      return;
    }
    try {
      setWellMarkerIcon({
        url: wellIcon,
        scaledSize: new window.google.maps.Size(40, 40),
        anchor: new window.google.maps.Point(20, 40),
      });
      setSelectedWellMarkerIcon({
        url: mapmarker,
        scaledSize: new window.google.maps.Size(40, 50),
        anchor: new window.google.maps.Point(20, 50),
      });
    } catch {
      setWellMarkerIcon(null);
      setSelectedWellMarkerIcon(null);
    }
  }, [isLoaded]);

  useEffect(() => {
    const map = mapRef.current;
    if (
      !map ||
      typeof map.setMapTypeId !== "function" ||
      !window.google?.maps?.event
    ) {
      return;
    }
    const id = window.setTimeout(() => {
      window.google.maps.event.trigger(map, "resize");
    }, 150);
    return () => window.clearTimeout(id);
  }, [mapHasSidePanel, wellMarkerIcon]);

  //divide the map into different regions
  const setMapCenterFunc = (lat, lng) => {
    if (mapRef.current) {
      mapRef.current.panTo({ lat, lng });
      mapRef.current.setZoom(10); // Set the desired zoom level
    } else {
      setMapCenter({ lat, lng });
      setZoom(10); // Set the desired zoom level
    }
    setMarkerPosition({ lat, lng }); // Set the marker position
  };

  const handleClearCircle = () => {
    setCircleCenter(null);
    setShowCircle(false);
    window.location.reload();
  };
  const [markersInsideCircle, setMarkersInsideCircle] = useState([]);

  const handleRadiusChange = (newRadius) => {
    setRadius(newRadius);
  };

  const getLatLongFromLocationId = (locationId) => {
    const location = locationMarkers.find(
      (loc) => loc.locationId === locationId,
    );
    return location
      ? { lat: location.lat, lng: location.lng }
      : { lat: 0, lng: 0 };
  };

  useEffect(() => {
    const parsedPaths = geoJson[0].coordinates;
    setPaths(parsedPaths);
    console.log("Parsed Paths:", parsedPaths);
  }, []);

  const getDatalogs = (wellId) => {
    fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/datalogs/${wellId}`)
      .then((res) => res.json())
      .then((datalogs) => {
        setDatalogs(datalogs);
        // console.log(datalogs);
      })
      .catch((err) => console.error(err));
  };

  const getImDatalogs = (wellId) => {
    fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/imdatalogs/${wellId}`)
      .then((res) => res.json())
      .then((imdatalogs) => {
        setimDatalogs(imdatalogs);
        // console.log(imdatalogs);
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    fetch("https://warpo-dashboard.cse.buet.ac.bd/api/wells")
      .then((res) => res.json())
      .then((markers) => {
        setMarkers(markers);
        console.log(markers);
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    fetch("https://warpo-dashboard.cse.buet.ac.bd/api/location")
      .then((res) => res.json())
      .then((locationMarkers) => {
        setLocationMarkers(locationMarkers);
        // console.log(locationMarkers);
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    fetch("https://warpo-dashboard.cse.buet.ac.bd/api/regions")
      .then((res) => res.json())
      .then((reg) => {
        setRegions(reg);
        console.log(reg);
        // reg.forEach((region) => {
        //   console.log("Region coordinate:", region.coordinates);
        // });
      })
      .catch((err) => console.error(err));
  }, []);

  function getStrokeColor(criticalLevel) {
    switch (criticalLevel) {
      case 1:
        return "green";
      case 2:
        return "lime";
      case 3:
        return "yellow";
      case 4:
        return "orange";
      case 5:
        return "red";
      default:
        return "black"; // Default color if critical level is not in the range
    }
  }

  const [polygons, setPolygons] = useState([]);

  useEffect(() => {
    const parsedPolygons = regions.map((region) => ({
      regionId: region.regionId,
      paths: region.coordinates,
      critical_level: region.critical_level,
    }));

    setPolygons(parsedPolygons);
  }, [regions]);

  useEffect(() => {
    const parsedDivisionPolygons = divisionJson.map((dv) => ({
      division_name: dv.division,
      division_coordinates: dv.coordinates,
    }));

    setDivisionPaths(parsedDivisionPolygons);
    console.log("Parsed Division Paths:", parsedDivisionPolygons);
  }, []);

  useEffect(() => {
    const parsedDistrictPolygons = districtJson.map((d) => ({
      district_name: d.district,
      district_coordinates: d.coordinates,
    }));

    setDistrictPaths(parsedDistrictPolygons);
    console.log("Parsed Division Paths:", parsedDistrictPolygons);
  }, []);

  const mapWellsToRegions = () => {
    const regionMappings = polygons.map((polygon) => {
      const markersInRegion = markers.filter((marker) =>
        isPointInPolygon(marker, polygon.paths),
      );

      return {
        regionId: polygon.regionId,
        markers: markersInRegion,
        markerCount: markersInRegion.length,
        critical_level: polygon.critical_level,
      };
    });

    return regionMappings;
  };

  useEffect(() => {
    console.log("Circle Center:", circleCenter);
    console.log("Radius:", radius);
    countMarkersInsideCircle();
  }, [circleCenter, radius]);

  function isPointInPolygon(markerPoint, polygon) {
    let inside = false;

    const point = getLatLongFromLocationId(markerPoint.locationId);

    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i].lat;
      const yi = polygon[i].lng;
      const xj = polygon[j].lat;
      const yj = polygon[j].lng;

      const intersect =
        yi > point.lng !== yj > point.lng && // Check if point.lng is between yi and yj
        point.lat < ((xj - xi) * (point.lng - yi)) / (yj - yi) + xi; // Calculate intersection

      if (intersect) inside = !inside;
    }

    return inside;
  }

  const getWellMarkerCount = (regionId) => {
    const polygon = polygons.find((p) => p.regionId === regionId);
    if (!polygon) {
      console.error(`Polygon with region ID ${regionId} not found`);
      return 0;
    }

    let count = 0;

    markers.forEach((marker) => {
      if (isPointInPolygon(marker, polygon.paths)) {
        count++;
      }
    });

    return count;
  };

  const getWellMarkersInRegion = (regionId) => {
    const polygon = polygons.find((p) => p.regionId === regionId);
    if (!polygon) {
      console.error(`Polygon with region ID ${regionId} not found`);
      return [];
    }

    const markersInRegion = markers
      .map((marker) => {
        if (isPointInPolygon(marker, polygon.paths)) {
          return marker;
        }
        return null;
      })
      .filter((marker) => marker !== null);

    return markersInRegion;
  };

  const handleRegionClick = (polygon) => {
    if (showRegionInfo) {
      setRegionClicked(polygon);
      console.log("Region clicked:", polygon.regionId);

      // const count = getWellMarkerCount(polygon.regionId);

      // console.log(
      //   `Number of well markers inside region ${polygon.regionId}:`,
      //   count
      // );
    }
  };

  const handleMapClick = (event) => {
    const clickedLatLng = {
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    };

    // Update state with clicked latitude and longitude
    setLatLng(clickedLatLng);

    // Reverse geocode to fetch the address of the clicked location
    reverseGeocode(clickedLatLng);

    // Set the circle's center to the clicked location
    setCircleCenter(clickedLatLng);
    console.log("circle center:", circleCenter);
    // Display the circle on the map
    setShowCircle(true);

    // // Show the marker at the clicked location
    // setMarkerPosition(clickedLatLng);

    if (mapRef.current) {
      // Pan the map to the clicked location
      mapRef.current.panTo(clickedLatLng);

      // Optionally adjust the zoom level
      mapRef.current.setZoom(10);
    }

    // Log the clicked location and updated circle center
    console.log("Marker and Circle Center Set To:", clickedLatLng);
    console.log("Original Circle Center:", circleCenter);
  };

  const [mapType, setMapType] = useState("roadmap");

  const handleMapToggle = () => {
    const mapTypes = ["roadmap", "terrain", "satellite", "hybrid"];
    const nextTypeIndex = (mapTypes.indexOf(mapType) + 1) % mapTypes.length;
    setMapType(mapTypes[nextTypeIndex]);
  };

  const onMapLoad = (mapInstance) => {
    mapRef.current = mapInstance;
    // // --- NEW: fit entire Bangladesh ---
    //   const bounds = new window.google.maps.LatLngBounds();
    // // geoJson[0].coordinates is an array of polygons; each polygon is an array of {lat,lng}
    //   geoJson[0].coordinates.forEach(polygon =>
    //       polygon.forEach(({ lat, lng }) => {
    //           bounds.extend({ lat, lng });
    //         })
    //     );
    // mapInstance.fitBounds(bounds);
    // // --- end NEW ---
    mapInstance.setCenter({ lat: 23.685, lng: 90.3563 });
    mapInstance.setZoom(7);
  };
  const reverseGeocode = (latLng) => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === "OK" && results[0]) {
        setUserFriendlyLocation(results[0].formatted_address);
      } else {
        setUserFriendlyLocation("Location not found");
      }
    });
  };
  const haversineDistance = (coords1, coords2) => {
    const toRad = (x) => (x * Math.PI) / 180;
    const R = 6371; // Radius of the Earth in km
    const dLat = toRad(coords2.lat - coords1.lat);
    const dLng = toRad(coords2.lng - coords1.lng);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(coords1.lat)) *
        Math.cos(toRad(coords2.lat)) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in km
  };

  const countMarkersInsideCircle = () => {
    if (!circleCenter || radius <= 0) {
      setMarkersInsideCircle([]); // Set to empty array if no circle or radius is invalid
      return;
    }

    const convertToFloat = (str) => {
      // Remove the last two characters
      const trimmedStr = str.slice(0, -2);
      // Convert the resulting string to a float
      return parseFloat(trimmedStr);
    };
    const markersInside = markers.filter((marker) => {
      const distance = haversineDistance(circleCenter, marker.location);
      marker.distance = distance;
      marker.decreasedlevel = marker.waterlevel - 0.5 * distance;
      // Assuming this is within a function where marker and distance are defined
      console.log("marker.waterlevel:", marker.waterlevel);
      console.log("distance:", distance);
      const numericValue = convertToFloat(marker.waterlevel);

      marker.decreasedlevel = numericValue - 0.1 * distance;
      console.log("marker.decreasedlevel:", marker.decreasedlevel);

      return distance <= radius;
    });

    setMarkersInsideCircle(markersInside); // Set the state with the array of markers inside the circle
  };

  useEffect(() => {
    const map = mapRef.current;
    if (map && typeof map.setMapTypeId === "function") {
      map.setMapTypeId(mapType);
    }
  }, [mapType]);

  const handleMapCenter = (lat, lng) => {
    if (mapRef.current) {
      mapRef.current.panTo({ lat, lng });
      mapRef.current.setZoom(10); // Adjust zoom level
    }
  };

  // --- NEW HANDLERS ---
  const handleDivisionSelect = (divisionId) => {
    if (!divisionId) return;
    // get the chosen division name
    const divName = divisionData.divisions.find(
      (d) => d.id === divisionId,
    ).name;
    // find its boundary polygon
    const poly = divisionPaths.find((p) => p.division_name === divName);
    if (poly) {
      const bounds = new window.google.maps.LatLngBounds();
      poly.division_coordinates.forEach(({ lat, lng }) =>
        bounds.extend({ lat, lng }),
      );
      mapRef.current.fitBounds(bounds);
    }
  };

  const handleDistrictSelect = (districtId) => {
    if (!districtId) return;
    const distName = districtData.districts.find(
      (d) => d.id === districtId,
    ).name;
    const poly = districtPaths.find((p) => p.district_name === distName);
    if (poly) {
      const bounds = new window.google.maps.LatLngBounds();
      poly.district_coordinates.forEach(({ lat, lng }) =>
        bounds.extend({ lat, lng }),
      );
      mapRef.current.fitBounds(bounds);
    }
  };
  // --- end NEW HANDLERS ---

  const circleCenterSameAsSelectedWell =
    Boolean(circleCenter && selectedMarker?.locations) &&
    Math.abs(selectedMarker.locations.lat - circleCenter.lat) < 1e-5 &&
    Math.abs(selectedMarker.locations.lng - circleCenter.lng) < 1e-5;

  return (
    <div
      className={
        mapHasSidePanel ? "map-layout map-layout--with-sidebar" : "map-layout"
      }
    >
      <Navbar
        className="navbar"
        // setMapCenterFunc={setMapCenterFunc}
        // setZoom={setZoom}
        onDivisionSelect={handleDivisionSelect}
        onDistrictSelect={handleDistrictSelect}
        setMapCenterFunc={handleMapCenter}
        setZoom={setZoom}
        showRegionInfo={showRegionInfo}
        setShowRegionInfo={setShowRegionInfo}
        mapRef={mapRef}
        handleClearLeftbar={handleClearLeftbar}
        selectedMarker={selectedMarker}
        setSelectedMarker={setSelectedMarker}
        setCircleCenter={setCircleCenter}
        wells={markers}
      />
      {selectedMarker && (
        <Leftbar
          className="leftbar"
          selectedMarker={selectedMarker}
          setSelectedMarker={setSelectedMarker}
          datalogs={datalogs}
          setDatalogs={setDatalogs}
          firstImdatalogs={imdatalogs}
          firstMultiColImDatalogs={multiColImDatalogs}
          showRegionInfo={showRegionInfo}
          setShowRegionInfo={setShowRegionInfo}
          getStrokeColor={getStrokeColor}
          regions={regions}
          handleClearLeftbar={handleClearLeftbar}
          selectedColor={selectedColor}
          setSelectedColor={setSelectedColor}
          getWellMarkerCount={getWellMarkerCount}
          regionClicked={regionClicked}
          setRegionClicked={setRegionClicked}
          getWellMarkersInRegion={getWellMarkersInRegion}
        />
      )}

      {isLoaded && (
        <div className="map-layout__map-host">
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            center={mapCenter}
            zoom={10}
            onLoad={onMapLoad}
            onClick={handleMapClick}
            style={{ zIndex: 1 }}
          >
            {divisionPaths.map((polygon) => (
              <Polygon
                key={polygon.division_name}
                paths={polygon.division_coordinates}
                options={{
                  fillColor: "transparent",
                  fillOpacity: 0.0,
                  strokeColor: "#000000",
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  clickable: false,
                }}
              />
            ))}

            {districtPaths.map((polygon) => (
              <Polygon
                key={polygon.district_name}
                paths={polygon.district_coordinates}
                options={{
                  fillColor: "transparent",
                  fillOpacity: 0.0,
                  strokeColor: "#000000",
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  clickable: false,
                }}
              />
            ))}

            {/* {showRegionInfo &&
              polygons.map((polygon) => (
                <Polygon
                  key={polygon.regionId}
                  paths={polygon.paths}
                  options={{
                    fillColor: getStrokeColor(polygon.critical_level),
                    fillOpacity: 0.35,
                    strokeColor: "#000000",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    clickable: true,
                  }}
                  onClick={() => handleRegionClick(polygon)}
                />
              ))} */}

            {markerPosition && window.google?.maps && (
              <Marker
                position={markerPosition}
                icon={{
                  url: mapmarkergreen,
                  scaledSize: new window.google.maps.Size(20, 20),
                }}
              />
            )}

            <ChangeMapType handleMapToggle={handleMapToggle} />
            {circleCenter && !circleCenterSameAsSelectedWell && (
              <Marker position={circleCenter} />
            )}

            {markers.map((marker) => {
              const position = marker.locations
                ? { lat: marker.locations.lat, lng: marker.locations.lng }
                : null;

              if (!position || !position.lat || !position.lng) return null;

              const isSelected =
                selectedMarker &&
                String(marker.wellId) === String(selectedMarker.wellId);

              return (
                <Marker
                  key={marker.wellId}
                  position={position}
                  icon={
                    isSelected
                      ? selectedWellMarkerIcon || mapmarker
                      : wellMarkerIcon || wellIcon
                  }
                  onClick={() => {
                    setSelectedMarker(marker);
                    setCircleCenter(position);
                    const map = mapRef.current;
                    if (map && typeof map.panTo === "function") {
                      map.panTo(position);
                      map.setZoom(10);
                    }
                  }}
                  zIndex={isSelected ? 1000 : 2}
                />
              );
            })}
          </GoogleMap>
        </div>
      )}
    </div>
  );
};

export default Map;
